module.exports = __webpack_public_path__ + "static/media/third-quote.a7e6083b.jpg";